<template>
  <div class="autorizacao">
    <div class="mb-2" style="text-align: right">
      <v-btn color="cyan" small :disabled="filtros.loading" :dark="!filtros.loading" to="/cancelamento-diario/novo" class="rounded-sm font-weight-regular" width="90px">Novo</v-btn>
    </div>

    <v-alert type="error" v-if="$v.filtros.$invalid && $v.filtros.$dirty" :value="true" color="error">
      <div>Atenção: Verifique os campos obrigatórios, antes de iniciar a busca.</div>
    </v-alert>
    <v-alert type="error"  style="color: white;" v-if="filtros.noResult && filtros.loading == false" :value="true">
        <div>Nenhuma autorização cadastrada!</div>
    </v-alert>
    <v-alert v-if="filtros.loading" :value="true" color="info" icon="info" >
      <div class="white--text">Por favor aguarde, estamos realizando a busca...</div>
    </v-alert>
    <br />

    <form @submit.prevent="handleSearch">
      <v-layout row wrap>
        <v-flex xs-12 md-1>
          <Select style="width: 97%;" label="Ano letivo*" v-model="filtros.aaletivo" :options="optionsAnos" :v="$v.filtros.aaletivo" :disabled="filtros.loading || loadingGeral" @change="setPeriodo()"/>
        </v-flex>
        <v-flex xs-12 md-2>
          <Input style="width: 97%;" type="date" label="Dt Abertura" :disabled="filtros.loading" :v="$v.filtros.dataaberturacancelamento" v-model.trim="filtros.dataaberturacancelamento"/>
        </v-flex>
        <v-flex xs-12 md-2>
          <Input style="width: 97%;" type="date"  label="Dt Fechamento" :disabled="filtros.loading"  :v="$v.filtros.datafechamentocancelamento" v-model.trim="filtros.datafechamentocancelamento"/>
        </v-flex>
        <v-flex xs12 md3>
          <Select style="width: 98%;" :label="`Nível Ensino* (${ optionsNivelEnsino.length == 0 ?  optionsNivelEnsino.length : optionsNivelEnsino.length - 1 })`" :disabled="filtros.loading || (loadingGeral && !loadingNivelEnsino)" v-model="filtros.cdinstruc" :options="optionsNivelEnsino" :v="$v.filtros.cdinstruc" @focus="loadNivelDeEnsino"  @change="changeNivelDeEnsino"/>
        </v-flex>
        <v-flex xs12 md3>
          <Select style="width: 98%;" :label="`Período Avaliativo* (${ optionsPeriodo.length == 0 ?  optionsPeriodo.length : optionsPeriodo.length - 1 })`" :disabled="!filtros.cdinstruc || filtros.loading || (loadingGeral && !loadingPeriodo)" :options="optionsPeriodo" v-model="filtros.cdpravadi" :v="$v.filtros.cdpravadi" @focus="loadPeriodoAvaliativo" @change="changePeriodoAvaliativo"/>
        </v-flex>
        <v-flex xs12 md4>
          <Select :disabled="filtros.loading || filtros.cdpravadi == '' || (loadingGeral && !loadingEtapaEscolar)" style="width: 98%;" :label="`Etapa Escola (${ optionsEtapaEscolar.length == 0 ?  optionsEtapaEscolar.length : optionsEtapaEscolar.length - 1 })`" v-model="filtros.cdserie" :options="optionsEtapaEscolar" @focus="loadEtapaEscolar" @change="changeEtapaEscolar"/>
        </v-flex>
        <v-flex xs12 md4>
          <Select :disabled="filtros.loading || filtros.cdpravadi == '' || (loadingGeral && !loadingEscola)" style="width: 98%;" :label="`Escola (${ optionsEscola.length == 0 ?  optionsEscola.length : optionsEscola.length - 1 })`" v-model="escolaSelected" :options="optionsEscola" @focus="loadEscola" @change="changeEscola" />
        </v-flex>
        <v-flex xs12 md4>
          <Select :disabled="filtros.loading || filtros.cdpravadi == '' || (loadingGeral && !loadingProfessor)" style="width: 98%;" :label="`Professor (${ optionsProfessor.length == 0 ?  optionsProfessor.length : optionsProfessor.length - 1 })`" v-model="professorSelected" :options="optionsProfessor" @focus="loadProfessor" @change="changeProfessor" />
        </v-flex>
        <v-flex xs12 md4>
          <Select :disabled="filtros.loading || filtros.cdpravadi == '' || (loadingGeral && !loadingTurma)" style="width: 98%;" :label="`Turma (${ optionsTurma.length == 0 ?  optionsTurma.length : optionsTurma.length - 1 })`" :options="optionsTurma" v-model="filtros.cdturma" @focus="loadTurma" @change="changeTurma" />
        </v-flex>
        <v-flex xs12 md4>
          <Select :disabled="filtros.loading || filtros.cdpravadi == '' || (loadingGeral && !loadingDisciplina)" style="width: 98%;" :label="`Disciplina (${ optionsDisciplina.length == 0 ?  optionsDisciplina.length : optionsDisciplina.length - 1 })`" :options="optionsDisciplina" v-model.number="filtros.cddiscipl" @focus="loadDisciplina" />
        </v-flex>
        <v-flex xs12 md12>
          <v-btn :loading="filtros.loading || filtros.loading" :disabled="loadingGeral" small type="submit" color="cyan" :dark="!loadingGeral" class="rounded-sm font-weight-regular mb-3" width="90px">Buscar</v-btn>
        </v-flex>
      </v-layout>
    </form>

    <br />

    <div class="filtro-bloco-busca v-card" v-if="!filtros.loading">
      <div class="filtro-itens">
        <div>
          <strong>Ano letivo: * </strong>
          <span>{{ filtros.aaletivo }} </span><br />
          <strong>Período: *</strong> {{ filtros.dataaberturacancelamento  | formatDataBR }} <strong>até</strong>  {{ filtros.datafechamentocancelamento  | formatDataBR }} <br />
          <strong>Nível de Ensino: * </strong>
          <span>{{ filtros.cdinstruc == '' ? 'Todos' : getLabelFiltro(optionsNivelEnsino, this.filtros.cdinstruc) }} </span><br />
          <strong>Período Avaliativo: * </strong>
          <span>{{ filtros.cdpravadi == '' ? 'Todos' : getLabelFiltro(optionsPeriodo, this.filtros.cdpravadi) }} </span><br />
          <strong>Etapa Escolar: </strong>
          <span>{{ filtros.cdserie == '' ? 'Todas' : getLabelFiltro(optionsEtapaEscolar, this.filtros.cdserie) }} </span><br />
          <strong>Escola: </strong>
          <span>{{ escolaSelected == '' ? 'Todas' : JSON.parse(escolaSelected)['nmescola'] }} </span><br />
          <strong>Professor: </strong>
          <span>{{ professorSelected == '' ? 'Todos' : JSON.parse(professorSelected)['nmfuncion'] }} </span><br />
          <strong>Turma: </strong>
          <span>{{ filtros.cdturma == '' ? 'Todas' : getLabelFiltro(optionsTurma, this.filtros.cdturma) }} </span><br />
          <strong>Disciplina: </strong>
          <span>{{ filtros.cddiscipl == '' ? 'Todas' : getLabelFiltro(optionsDisciplina, this.filtros.cddiscipl) }} </span><br />
        </div>
      </div>
      <div>
        <strong>Resultados Encontrados:</strong> {{ paginaTotal }}
      </div>
    </div>

    <br />

    <v-card style="overflow-y: auto">
      <table class="table-siged">
        <thead>
          <tr>
            <th>Ano Letivo</th>
            <th>Período Avaliativo</th>
            <th>Nível Ensino</th>
            <th>Etapa Escolar</th>
            <th>Escola</th>
            <th>Professor</th>
            <th>Turma</th>
            <th>Disciplina</th>
            <th>Data Abertura</th>
            <th>Data Fechamento</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="auto in autorizacoes" :key="auto.identificadorautorizacaocancelamentodiario">
            <td class="centro">{{ auto.aaletivo }}</td>
            <td class="centro">{{ auto.periodo_avaliativo ? auto.periodo_avaliativo.dspravadi : '' }}</td>
            <td class="centro">{{ auto.nivel ? auto.nivel.dsinstruc : '' }}</td>
            <td class="centro">{{ auto.etapa_escolar ? auto.etapa_escolar.dsserie : '' }}</td>
            <td>{{ auto.escola ? auto.escola.nmescola : '' }}</td>
            <td class="centro">{{ auto.professor ? auto.professor.nmfuncion : '' }}</td>
            <td class="centro">{{ auto.turma ? auto.turma.nmturma : '' }}</td>
            <td class="centro">{{ auto.disciplina ? auto.disciplina.dsdiscipl : '' }}</td>
            <td class="centro">{{ auto.dataaberturacancelamento | formatDataBR }}</td>
            <td class="centro">{{ auto.datafechamentocancelamento | formatDataBR }}</td>
            <td class="centro">
              <v-btn icon title="Editar" class="aulas-btn-acao" :to="{ path: `/cancelamento-diario/${auto.identificadorautorizacaocancelamentodiario}` }">
                <v-icon class="btn-acoes-icon">edit</v-icon>
              </v-btn>
              <v-btn icon title="Excluir" class="aulas-btn-acao" @click="excluir(auto.identificadorautorizacaocancelamentodiario)">
                <v-icon color="red">delete_forever</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="quantidadePaginas > 1" class="table-siged-page" style="text-align: right">
        <v-pagination v-model="paginaAtual" :length="quantidadePaginas" total-visible="7" />
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
      <div class="d-flex justify-space-between align-center">
        <span> {{ submitText }}</span>
        <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import api from '@/api'
const CancelamentoDiarioRepository = RepositoryFactory.get('cancelamentoDiario');

export default {
  name: 'CancelamentoDiario',
  data() {
    return {
      loadingGeral: false,
      loadingNivelEnsino: false,
      loadingPeriodo: false,
      loadingEtapaEscolar: false,
      loadingEscola: false,
      loadingProfessor: false,
      loadingTurma: false,
      loadingDisciplina: false,
      filtros: {
        loading: false,
        noResult: false,
        aaletivo: new Date().getFullYear(),
        minDate: `${new Date().getFullYear()}-01-01`,
        dataaberturacancelamento: `${new Date().getFullYear()}-01-01`,
        datafechamentocancelamento: `${new Date().getFullYear()}-12-31`,
        cdinstruc: "",
        dsinstruc: "",
        cdpravadi: "",
        dspravadi: "",
        cdserie: "",
        dsserie: "",
        cdescola: "",
        cdtipesc: "",
        nmescola: "",
        cdpessoal: "",
        cdmatric: "",
        nmfuncion: "",
        cdturma: "",
        nmturma: "",
        cddiscipl: "",
        dsdiscipl: "",
      },
      escolaSelected: '',
      professorSelected: '',
      autorizacoes: [],
      paginaAtual: 1,
      paginaTotal: 0,
      filtroBusca: [],
      quantidadePaginas: 0,
      snackbar: false,
      submitText: '',
      optionsNivelEnsino: [],
      optionsEtapaEscolar: [],
      optionsEscola: [],
      optionsProfessor: [],
      optionsTurma: [],
      optionsDisciplina: [],
      optionsPeriodo: []

    };
  },
  validations: {
    filtros: {
        aaletivo: { required, minLength: minLength(4), maxLength: maxLength(4) },
        dataaberturacancelamento: { required },
        datafechamentocancelamento: { required },
        cdinstruc: { required },
        cdpravadi: { required },
    },
  },
  watch: {
    paginaAtual() {
      this.handleSearch(this.paginaAtual);
    }
  },
  created() {
    this.autorizacoes = [];
  },
  async beforeRouteEnter(to, from, next){
    next(vm => vm.reload());
    next(vm => null);
  },
  methods: {
    getLabelFiltro(lista, fieldValue){
      const item = lista.find(item => item.value == fieldValue);
      if(item) { return item.text; }
      return '';
    },
    getFiltros() {
      const {cdescola , cdtipesc} = (this.escolaSelected) ? JSON.parse(this.escolaSelected) : {cdtipesc: '', cdescola: '', nmescola: 'Todas'};
      const {cdpessoal , cdmatric} = (this.professorSelected) ? JSON.parse(this.professorSelected) : {cdpessoal: '', cdmatric: '', nmfuncion: 'Todos'};
      let filtros = {...this.filtros, cdescola, cdtipesc, cdpessoal, cdmatric};

      filtros.cdserie = filtros.cdserie == '*' ? '' : filtros.cdserie;
      filtros.cdturma = filtros.cdturma == '*' ? '' : filtros.cdturma;
      filtros.cddiscipl = filtros.cddiscipl == '*' ? '' : filtros.cddiscipl;

      return filtros;
    },
    setPeriodo() {
      if(this.filtros && this.filtros.aaletivo.length >= 4) {
        this.filtros.minDate = `${this.filtros.aaletivo}-01-01`;
        this.filtros.dataaberturacancelamento = `${this.filtros.aaletivo}-01-01`;
        this.filtros.datafechamentocancelamento = `${this.filtros.aaletivo}-12-31`;

        this.filtros.cdinstruc = '';
        this.filtros.cdpravadi= '';
        this.filtros.dspravadi= '';
        this.filtros.cdserie= '';
        this.filtros.dsserie= '';
        this.escolaSelected = '';
        this.filtros.cdescola= '';
        this.filtros.cdtipesc= '';
        this.filtros.nmescola= '';
        this.professorSelected = '';
        this.filtros.cdpessoal = '';
        this.filtros.cdmatric= '';
        this.filtros.nmfuncion= '';
        this.filtros.cdturma= '';
        this.filtros.nmturma= '';
        this.filtros.cddiscipl= '';
        this.filtros.dsdiscipl= '';
        this.optionsNivelEnsino = [];
        this.optionsPeriodo = [];
        this.optionsEtapaEscolar = [];
        this.optionsEscola = [];
        this.optionsProfessor = [];
        this.optionsTurma = [];
        this.optionsDisciplina = [];
      }
    },
    changeNivelDeEnsino() {
      this.filtros.cdpravadi= '';
      this.filtros.dspravadi= '';
      this.filtros.cdserie= '';
      this.filtros.dsserie= '';
      this.escolaSelected = '';
      this.filtros.cdescola= '';
      this.filtros.cdtipesc= '';
      this.filtros.nmescola= '';
      this.professorSelected = '';
      this.filtros.cdpessoal = '';
      this.filtros.cdmatric= '';
      this.filtros.nmfuncion= '';
      this.filtros.cdturma= '';
      this.filtros.nmturma= '';
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsPeriodo = [];
      this.optionsEtapaEscolar = [];
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
    },
    changePeriodoAvaliativo() {
      this.filtros.cdserie= '';
      this.filtros.dsserie= '';
      this.escolaSelected = '';
      this.filtros.cdescola= '';
      this.filtros.cdtipesc= '';
      this.filtros.nmescola= '';
      this.professorSelected = '';
      this.filtros.cdpessoal = '';
      this.filtros.cdmatric= '';
      this.filtros.nmfuncion= '';
      this.filtros.cdturma= '';
      this.filtros.nmturma= '';
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsEtapaEscolar = [];
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
    },
    changeEtapaEscolar() {
      this.escolaSelected = '';
      this.filtros.cdescola= '';
      this.filtros.cdtipesc= '';
      this.filtros.nmescola= '';
      this.professorSelected = '';
      this.filtros.cdpessoal = '';
      this.filtros.cdmatric= '';
      this.filtros.nmfuncion= '';
      this.filtros.cdturma= '';
      this.filtros.nmturma= '';
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsEscola = [];
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
    },
    changeEscola() {
      this.professorSelected = '';
      this.filtros.cdpessoal = '';
      this.filtros.cdmatric= '';
      this.filtros.nmfuncion= '';
      this.filtros.cdturma= '';
      this.filtros.nmturma= '';
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsProfessor = [];
      this.optionsTurma = [];
      this.optionsDisciplina = [];
    },
    changeProfessor() {
      this.filtros.cdturma= '';
      this.filtros.nmturma= '';
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsTurma = [];
      this.optionsDisciplina = [];
    },
    changeTurma() {
      this.filtros.cddiscipl= '';
      this.filtros.dsdiscipl= '';
      this.optionsDisciplina = [];
    },
    async loadNivelDeEnsino() {

      if (this.optionsNivelEnsino.length > 0) return;

      try{
        this.loadingNivelEnsino = true;
        this.loadingGeral = true;
        const { data } = await api.get(`ei/nivelensino/${this.filtros.aaletivo}`)

        this.optionsNivelEnsino = data.results.map(key => ({ value: key.cdinstruc, text: `${key.cdinstruc} - ${key.dsinstruc}` }));
        this.optionsNivelEnsino.unshift({ value: '', text: '' });
      } finally {
        this.loadingNivelEnsino = false;
        this.loadingGeral = false;
      }
    },
    async loadPeriodoAvaliativo() {
      if (this.optionsPeriodo.length > 0) return;

      try{
        this.loadingPeriodo = true;
        this.loadingGeral = true;

        const params = {
          aaletivo: this.filtros.aaletivo,
          cdinstruc: this.filtros.cdinstruc
        };

        const { data } = await api.get('ei/periodo-avaliativo/getPeriodoAvaliativoPorNivelDeEnsino', {params});

        this.optionsPeriodo = data.results.map(key => ({ value: key.cdpravadi, text: `${key.dspravadi}` }));
        this.optionsPeriodo.unshift({ value: '', text: '' });
      } finally {
        this.loadingPeriodo = false;
        this.loadingGeral = false;
      }
    },
    async loadEtapaEscolar() {
      if (this.optionsEtapaEscolar.length > 0) return;

      try{
        this.loadingEtapaEscolar = true;
        this.loadingGeral =  true;

        const { data } = await api.get('ei/etapaescolar/getEtapaEscolarPorDescricao', {params: this.getFiltros()});

        this.optionsEtapaEscolar = data.results.map(key => ({ value: key.cdserie, text: `${key.dsserie}` }));
        this.optionsEtapaEscolar.unshift({ value: '*', text: 'Todas' });
        this.filtros.cdserie = '*';
      } finally {
        this.loadingEtapaEscolar = false;
        this.loadingGeral =  false;
      }
    },
    async loadEscola() {
      if (this.optionsEscola.length > 0) return;

      try{
        this.loadingEscola = true;
        this.loadingGeral =  true;

        const { data } = await api.get('ei/escola/getEscolaPorNome', {params: this.getFiltros()});

        this.optionsEscola = data.results.map(key => ({ value: JSON.stringify({ cdtipesc: parseInt(key.cdtipesc), cdescola: parseInt(key.cdescola), nmescola:  key.nmescola }), text: key.nmescola }));
        this.optionsEscola.unshift({ value: JSON.stringify({cdtipesc: '', cdescola: '', nmescola: 'Todas'}), text: 'Todas' });
        this.escolaSelected = JSON.stringify({cdtipesc: '', cdescola: '', nmescola: 'Todas'});
      } finally {
        this.loadingEscola = false;
        this.loadingGeral =  false;
      }
    },
    async loadProfessor() {
      if (this.optionsProfessor.length > 0) return;

      try{
        this.loadingProfessor = true;
        this.loadingGeral =  true;

        const { data } = await api.get('ei/professor/getProfessorPorNome', {params: this.getFiltros()});

        this.optionsProfessor = data.results.map(key => ({ value: JSON.stringify({ cdpessoal: parseInt(key.cdpessoal), cdmatric: parseInt(key.cdmatric), nmfuncion: key.nmfuncion }), text: key.nmfuncion }));
        this.optionsProfessor.unshift({ value: JSON.stringify({cdpessoal: '', cdmatric: '', nmfuncion: 'Todos'}), text: 'Todos' });
        this.professorSelected = JSON.stringify({cdpessoal: '', cdmatric: '', nmfuncion: 'Todos'})
      } finally {
        this.loadingProfessor = false;
        this.loadingGeral =  false;
      }
    },
    async loadTurma() {
      if (this.loadingTurma.length > 0) return;

      try{
        this.loadingTurma = true;
        this.loadingGeral =  true;

        const { data } = await api.get('ei/turma/getTurmaPorNome', {params: this.getFiltros()});

        this.optionsTurma = data.results.map(key => ({ text: `${key.nmturma} - ${key.horario}`, value: key.cdturma }));
        this.optionsTurma.unshift({ value: '*', text: 'Todas' });
        this.filtros.cdturma = '*';
      } finally {
        this.loadingTurma = false;
        this.loadingGeral =  false;
      }
    },
    async loadDisciplina() {
      if (this.optionsDisciplina.length > 0) return;

      try {
        this.loadingDisciplina = true;
        this.loadingGeral =  true;

        const { data } = await api.get('ei/disciplina/getDisciplinaPorNome', {params: this.getFiltros()});

        this.optionsDisciplina = data.results.map(key => ({ text: key.dsdiscipl, value: key.cddiscipl }));
        this.optionsDisciplina.unshift({ value: '*', text: 'Todas' });
        this.filtros.cddiscipl = '*';
      } finally {
        this.loadingDisciplina = false;
        this.loadingGeral =  false;
      }
    },
    handleItemSelecionado(item){
        const keys = Object.keys(this.filtros);

          keys.forEach(key => {
            if(key in item) {
              this.filtros[key] = item[key];
            }
          });

        if(Object.keys(item).includes('cdinstruc')) {
          this.filtros.cdpravadi = "";
          this.filtros.dspravadi = "Todos";
          this.filtros.cdserie = "";
          this.filtros.dsserie = "Todos";
          this.filtros.cdescola = "";
          this.filtros.cdtipesc = "";
          this.filtros.nmescola = "Todas";
          this.filtros.cdmatric = "";
          this.filtros.nmfuncion = "Todos";
          this.filtros.cdturma = "";
          this.filtros.nmturma = "Todas";
          this.filtros.cddiscipl = "";
          this.filtros.dsdiscipl = "Todas";
       }
    },
    async handleSearch(page = 1) {
      try{
        this.$v.$touch();
        if (this.$v.$invalid) { return; }

        this.filtros.loading = true;
        this.autorizacoes = [];
        this.quantidadePaginas = 0;
        this.$Progress.start();

        const params = {
          page,
          ...this.getFiltros()
        };

        const response = await api.get('/ei/cancelamento-diario', { params });
        const  data = response.data;
        this.paginaAtual = data.results.current_page;
        this.autorizacoes = data.results.data;
        this.quantidadePaginas = data.results.last_page;
        this.paginaTotal = data.results.total;

        this.$Progress.finish();
        this.filtros.loading = false;
        this.autorizacoes.length ? this.filtros.noResult = false : this.filtros.noResult = true;
      } catch(error) {
        this.$Progress.finish();
        this.filtros.loading = false;
      }
    },
    async reload(data = null) {
      this.$Progress.finish();
    },

    async excluir(id) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta autorização?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await CancelamentoDiarioRepository.deleteCancelamento(id);
        this.submitText = data.message;
        this.snackbar = true;
        if(this.paginaAtual > 1 && this.telas.length == 1) { this.paginaAtual--; }
        this.autorizacoes = this.autorizacoes.filter(item => item.identificadorautorizacaocancelamentodiario  !== id);
      } catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage,
            type: 'notification',
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters(['getAnoAtualServidor', 'getAnoInicioSistema']),
    optionsAnos() {
      const anosAtivos = []
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        anosAtivos.push({ text: i, value: i });
      }

      return [ ...anosAtivos ];
    },
  },
}
</script>

<style lang="scss" scoped>
.input-block {
  width: 100%;
}
::v-deep .custom-input .outline-block input[type="date"].outline-input {
  padding-top: 13px !important;
  padding-bottom: 7px !important;
}
.autorizacao {
  margin: 0px 15px;
}

.filtro-bloco-busca {
    border: 1px solid #999999;
    background: white;
    padding: 20px;
    border-radius: 4px;
    font-size: 16px;

    .filtro-itens {
      display: flex;
      flex-wrap: wrap;
      div {
        min-width: 300px;
        margin-right: 10px;
      }
    }
  }
</style>
